// export default ManageItems;
import React, { useState, useEffect } from "react";

import { Link } from "react-router-dom";
import { Stepper, Step } from "react-form-stepper";
import StepWizard from "react-step-wizard";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import Loader from "../../../../components/Loader/Loader";
import ItemInfo from "./ItemInfo";
import Images from "./Images";
import Inventory from "./Inventory";
import Pricing from "./Pricing";
import Locations from "./Locations";
// import ItemsDetail from "./ItemsDetails";
// import ItemsRack from "./ItemsRack";

import { checkUserPermission } from "../../../../common/UserPermission";
let PERMISSION_ALLOWITEMQTYADDSUB = "allowitemqtyaddsub";

const ManageItems = () => {
  const [loading, setLoading] = useState(false);
  const [stepWizard, setStepWizard] = useState(null);
  const [user, setUser] = useState({});
  const [data, setData] = useState({});
  const [activeStep, setActiveStep] = useState(0);

  const assignStepWizard = (instance) => {
    setStepWizard(instance);
  };

  const callbackListofdata = (val) => {
    setData(val);
  };

  const assignUser = (val) => {
    setUser((user) => ({
      ...user,
      ...val,
    }));
  };

  const handleStepChange = (e) => {
    setActiveStep(e.activeStep - 1);
  };

  const handleComplete = () => {
    alert("You r done. TQ");
  };

  useEffect(() => {
    if (stepWizard !== null) {
      console.log(stepWizard, "stepWizard");
      setActiveStep(stepWizard.currentStep - 1);
    }
  }, [stepWizard, activeStep]);

  return (
    <>
      <Sidebar />

      <Loader loading={loading} />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          {/* <div className="row" style={{ marginTop: "-1.5rem" }}>
            <div
              className="col"
              style={{ display: "flex", alignItems: "baseline", gap: "1.5rem" }}
            >
              <span className="page-title m-0 p-0">New Item</span>
              {"  "}
              <span>
                <Link to="/dashboard">Dashboard</Link> /{" "}
                <Link to="/items">Items List</Link> / Manage Items
              </span>
            </div>
          </div> */}
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row" style={{ marginTop: "5px" }}>
              <h3 className="page-title">New Item</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">
                  <Link to="/items">Items List</Link> / Manage Items
                </li>
              </ul>
            </div>
          </div>
          <div className="row" style={{ marginTop: "-1.5rem" }}>
            <div className="col-md-12">
              <Stepper activeStep={activeStep}>
                <Step
                  onClick={() => {
                    setActiveStep(0);
                    stepWizard.goToStep(1);
                  }}
                  label="Item Info"
                />

                <Step
                  onClick={() => {
                    setActiveStep(1);
                    stepWizard.goToStep(2);
                  }}
                  label="Item Pricing"
                />
                <Step
                  onClick={() => {
                    setActiveStep(2);
                    stepWizard.goToStep(3);
                  }}
                  label="Inventory"
                />
                {/* <Step
                  onClick={() => {
                    setActiveStep(3);
                    stepWizard.goToStep(4);
                  }}
                  label="Item Rack"
                /> */}
                <Step
                  onClick={() => {
                    setActiveStep(3);
                    stepWizard.goToStep(4);
                  }}
                  label="Images"
                />
                <Step
                  onClick={() => {
                    setActiveStep(4);
                    stepWizard.goToStep(5);
                  }}
                  label="Locations"
                />
              </Stepper>

              <StepWizard
                instance={assignStepWizard}
                onStepChange={handleStepChange}
                initialStep={activeStep}
              >
                <ItemInfo
                  isActiveStep={activeStep === 0}
                  userCallback={assignUser}
                  Listofdata={data}
                />
                {/* <ItemsDetail
                  isActiveStep={activeStep === 1}
                  user={user}
                  userCallback={assignUser}
                  Listofdata={data}
                  callback={callbackListofdata}
                /> */}
                <Pricing
                  isActiveStep={activeStep === 1}
                  user={user}
                  userCallback={assignUser}
                  Listofdata={data}
                  callback={callbackListofdata}
                />
                <Inventory
                  isActiveStep={activeStep === 2}
                  user={user}
                  userCallback={assignUser}
                  Listofdata={data}
                  callback={callbackListofdata}
                />
                {/* <ItemsRack
                  isActiveStep={activeStep === 3}
                  user={user}
                  userCallback={assignUser}
                  Listofdata={data}
                /> */}
                <Images
                  isActiveStep={activeStep === 3}
                  user={user}
                  userCallback={assignUser}
                  Listofdata={data}
                  callback={callbackListofdata}
                />
                <Locations
                  isActiveStep={activeStep === 4}
                  user={user}
                  completeCallback={handleComplete}
                  Listofdata={data}
                />
              </StepWizard>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageItems;
